<div class="task-container">
	<div class="header">
		<attach-new-quick-entity
			[parentEntityData]="data()"
			[shownActions]="[ActionType.INCIDENT, ActionType.REQUEST]"
		/>

		<div class="action-button">
			<button
				mat-icon-button
				class="primary-icon-button"
				[matMenuTriggerFor]="addEntitiesMenu"
			>
				<mat-icon svgIcon="add"></mat-icon>
			</button>
		</div>
	</div>
	<div>
		<form-field-label [labelTranslateKey]="'checklist_status'" />

		<div class="status-cards-section">
			@if (template()?.overallCount > 0) {
				<mat-card class="status-card">
					<mat-card-title
						>{{ this.completed() }}/{{ template()?.overallCount }}</mat-card-title
					>

					<mat-card-subtitle>
						{{ 'checklist_completed_counter' | translate }}</mat-card-subtitle
					>
				</mat-card>
			}
			@if (this.openIncidents() > 0) {
				<mat-card class="status-card">
					<mat-card-title>{{ this.openIncidents() }}</mat-card-title>
					<mat-card-subtitle>
						{{
							'open_incidents' | translate: { value: this.openIncidents().toString() }
						}}</mat-card-subtitle
					>
				</mat-card>
			}
			@if (this.openRequests() > 0) {
				<mat-card class="status-card">
					<mat-card-title>{{ this.openRequests() }}</mat-card-title>
					<mat-card-subtitle>
						{{
							'open_requests' | translate: { value: this.openRequests().toString() }
						}}</mat-card-subtitle
					>
				</mat-card>
			}
		</div>
	</div>
	<div>
		<form-field-label [labelTranslateKey]="'filter'" />
		<div class="tasks-filters">
			<mat-chip-set>
				<mat-chip-option
					#checklistChip
					[selected]="data().checklists.length > 0"
					[selectable]="data().checklists.length > 0"
					>{{ 'checklist' | translate }}</mat-chip-option
				>
				<mat-chip-option
					#incidentChip
					[selected]="data().incidentWorkOrders.edges.length > 0"
					[selectable]="data().incidentWorkOrders.edges.length > 0"
					>{{ 'incident' | translate }}</mat-chip-option
				>
				<mat-chip-option
					#requestChip
					[selected]="data().requestWorkOrders.edges.length > 0"
					[selectable]="data().requestWorkOrders.edges.length > 0"
					>{{ 'requests' | translate }}
				</mat-chip-option>
			</mat-chip-set>
		</div>
	</div>
	@if (checklistChip.selected && data().checklists.length > 0) {
		<div>
			<form-field-label [labelTranslateKey]="'checklist'" />

			<div cdkDropList (cdkDropListDropped)="drop($event)">
				@for (item of template()?.options; track item; let i = $index) {
					<div class="checklist-item" cdkDrag>
						<entity-checklist-item
							[checklistItem]="item"
							[index]="i"
							(checklistChanged)="updateChecklistOption($event)"
						/>
					</div>
				}
			</div>
		</div>
	}
	<div class="attached-section">
		@if (incidentChip.selected && data().incidentWorkOrders.edges.length > 0) {
			<div class="attached-incidents">
				<p>{{ 'attached_incidents' | translate }}</p>
				@for (incident of data().incidentWorkOrders.edges; track incident.node.id) {
					<attached-entity-card
						[entity]="{ type: 'incident', data: incident.node }"
						(isSelected)="selectionChanged($event)"
					/>
				}
			</div>
		}
		@if (requestChip.selected && data().requestWorkOrders.edges.length > 0) {
			<div class="attached-requests">
				<p>{{ 'attached_requests' | translate }}</p>
				@for (request of data().requestWorkOrders.edges; track request.node.id) {
					<attached-entity-card
						[entity]="{ type: 'request', data: request.node }"
						(isSelected)="selectionChanged($event)"
					/>
				}
			</div>
		}
	</div>
</div>

<mat-menu #addEntitiesMenu="matMenu">
	<button mat-menu-item [mat-menu-trigger-for]="entityTypeMenu">
		<span>{{ 'add_existing' | translate }}</span>
	</button>
</mat-menu>

<mat-menu #entityTypeMenu="matMenu">
	<button mat-menu-item (click)="openAttachExistingEntities('incident')">
		<span>{{ 'incident' | translate }}</span>
	</button>
	<button mat-menu-item (click)="openAttachExistingEntities('request')">
		<span>{{ 'request' | translate }}</span>
	</button>
</mat-menu>
